import { render, staticRenderFns } from "./HistoryRecoveryRequest.vue?vue&type=template&id=4e0626b4&"
import script from "./HistoryRecoveryRequest.vue?vue&type=script&lang=js&"
export * from "./HistoryRecoveryRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports